import { render, staticRenderFns } from "./PartAndHalfTimeStudents.vue?vue&type=template&id=65bac872&scoped=true&"
import script from "./PartAndHalfTimeStudents.vue?vue&type=script&lang=js&"
export * from "./PartAndHalfTimeStudents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/jenkins_node_modules/doris/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65bac872",
  null
  
)

export default component.exports